<template>
  <div class="newsfeed">
    <div class="loading-dots" v-if="loadingNew">
      <div class="dot-falling">
      </div>
    </div>

    <v-dialog v-model="addEditDialog" persistent max-width="900">
      <v-overlay :value="loadingImg">
        <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-card>
        <v-card-title class="headline">
          <v-row>
            <v-col>{{ isEdit ? $t('edit') : $t('add') }} {{$t('news_feed')}}</v-col>
            <v-col md="1" class="float-right">
              <!-- <v-btn icon @click="setEnableEdit()" class="mr-2 ml-2" color="primary" v-if="isEdit">
                <v-icon>mdi-pencil</v-icon>
              </v-btn> -->

              <v-btn icon @click="addEditDialog = false" class="mr-2 ml-2">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-form ref="watchForm">

            <v-card-text>
              <!-- Avatar -->
              <!-- <v-row>
                  <v-col md="3">
                    <v-text-field class="form-control" label="Reporter" disabled></v-text-field>
                  </v-col>
                  <v-col md="9">
                    <v-row>
                      <v-col md="2">
                        <v-avatar size="75" class="ma-1">
                          <img
                            :src="form.avatar"
                            alt="Avatar"
                            onerror="this.onerror=null;this.src='img/logo_initial_gradient.png'"
                          />
                        </v-avatar>
                      </v-col>
                      <v-col>
                        <v-card-title>HRD</v-card-title>
                        <v-card-subtitle>test</v-card-subtitle>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>-->

              <!-- Audience -->
              <!-- <v-row>
                  <v-col md="3">
                    <v-text-field class="form-control" label="Audience" disabled></v-text-field>
                  </v-col>
                  <v-col md="9">
                    <v-autocomplete
                      label="Audience"
                      :items="[{ id: 1, name: 'All Group' },{ id: 0, name: 'Test Group' }]"
                      v-model="form.audience"
                      item-text="name"
                      item-value="id"
                    ></v-autocomplete>
                    <span
                      v-if="form.audience == 1"
                    >Pesan ini akan terkirim ke semua group di perusahaan anda</span>
                    <span
                      v-if="form.audience == 0"
                    >Pesan ini akan terkirim ke group terpilih di perusahaan anda</span>
                  </v-col>
                </v-row>-->

              <!-- Subject -->
              <v-row>
                <!-- <v-col md="3">
                    <v-text-field class="form-control" label="Subject" disabled></v-text-field>
                  </v-col>-->
                <v-col cols="12" v-if="isEdit">
                  <v-select v-model="editItem.groups" :items="groupList" item-text="alias" item-value="id"
                    :label="$t('select_group')" multiple small-chips clearable>
                    <template v-slot:prepend-item>
                      <v-list-item ripple @click="toggleEdit">
                        <v-list-item-action>
                          <v-icon :color="
                              editItem.groups.length > 0
                                ? 'indigo darken-4'
                                : ''
                            ">
                            {{ icon }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{$t('select_all')}}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" v-else>
                  <v-select v-model="addItem.groupAccess" :items="groupList" item-text="alias" item-value="id"
                    :label="$t('select_group')" multiple small-chips clearable>
                    <template v-slot:prepend-item>
                      <v-list-item ripple @click="toggle">
                        <v-list-item-action>
                          <v-icon :color="
                              addItem.groupAccess.length > 0
                                ? 'indigo darken-4'
                                : ''
                            ">
                            {{ icon }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{$t('select_all')}}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                  </v-select>
                </v-col>
                <v-col>
                  <v-text-field :label="$t('title')" v-model="form.subject" counter="100" :disabled="isEdit == true"
                    :rules="[validator.alfaForNews]" @keyup="limitChar($event.target.value, 100, 'subject')">
                  </v-text-field>
                </v-col>

              </v-row>

              <!-- Description -->
              <v-row>
                <!-- <v-col md="3">
                    <v-text-field class="form-control" label="Description" disabled></v-text-field>
                  </v-col>-->
                <v-col>
                  <v-textarea auto-grow :label="$t('description')" class="form-control" rows="1"
                    v-model="form.description" counter="2000" :rules="[validator.alfaForNews]"
                    @keyup="limitChar($event.target.value, 2000, 'description')" :disabled="isEdit == true">
                  </v-textarea>
                </v-col>
              </v-row>

              <!-- Attachment -->
              <v-row>
                <!-- <v-col md="3">
                    <v-text-field class="form-control" label="Attachment" disabled></v-text-field>
                  </v-col>-->
                <v-col md="12" class="pt-0 pb-0">
                  <label>Attachment (Optional)</label>
                </v-col>
                <v-col>
                  <v-row>
                    <v-col md="4">
                      <img :src="form.image.one.url" @click="chooseFiles1()" :class="!isEdit ? 'allow-hover' : ''" @error="setAltImage" alt="img" width="250px" height="258px" style="border-radius: 8px; object-fit: cover;"/>
                      <v-file-input accept="image/*" id="image1" @change="previewImage(1)" v-model="form.image.one.data"
                        :messages="$t('this_will_be_cover')" :disabled="isEdit == true" style="display:none;"></v-file-input>
                    </v-col>
                    <v-col md="4">
                     <img :src="form.image.two.url" @click="chooseFiles2()" :class="!isEdit ? 'allow-hover' : ''" @error="setAltImage" alt="img" width="250px" height="258px" style="border-radius: 8px; object-fit: cover;"/>
                      <v-file-input accept="image/*" id="image2" @change="previewImage(2)" v-model="form.image.two.data"
                        :disabled="isEdit == true" style="display:none;"></v-file-input>
                    </v-col>
                    <v-col md="4">
                    <img :src="form.image.three.url" @click="chooseFiles3()" :class="!isEdit ? 'allow-hover' : ''" id="image" @error="setAltImage" alt="img" width="250px" height="258px" style="border-radius: 8px; object-fit: cover;"/>
                      <v-file-input accept="image/*" id="image3" @change="previewImage(3)" v-model="form.image.three.data"
                        :disabled="isEdit == true" style="display:none;"></v-file-input>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="4" class="pb-0">
                  <v-menu ref="menu" v-model="menu_start2" :close-on-content-click="false" transition="scale-transition"
                    offset-y min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field :value="dateFormatted(form.start_date)" label="Start Date" prepend-icon="mdi-calendar"
                        readonly v-on="on" color="primary"></v-text-field>
                    </template>
                    <v-date-picker v-model="form.start_date" @change="onStartDateChange2" no-title scrollable></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col md="4" class="pb-0">
                  <v-menu ref="menu" v-model="menu_end2" :close-on-content-click="false" transition="scale-transition"
                    offset-y min-width="290px">
                    <template v-slot:activator="{ on }" v-if="form.end_date">
                      <v-text-field :value="dateFormatted(form.end_date)" label="End Date" :disabled="form.period" prepend-icon="mdi-calendar"
                        readonly v-on="on" color="primary"></v-text-field>
                    </template>
                    <template v-slot:activator="{ on }" v-else>
                      <v-text-field value="-" label="End Date" :disabled="form.period" prepend-icon="mdi-calendar"
                        readonly v-on="on" color="primary"></v-text-field>
                    </template>
                    <v-date-picker v-model="form.end_date" @change="onEndDateChange2" :min="form.start_date" no-title scrollable>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                 <v-col md="4" class="pb-0">
                  <v-row align="center">
                    <v-col cols="3" class="cont_period" style="position: relative;">
                    <v-switch
                    @change="changePeriod(form.period)"
                      v-model="form.period"
                      :disabled="isEdit == true && enableEdit == false"
                    ></v-switch>
                    </v-col>
                    <v-col style="font-size: 16px;">
                    <span
                      v-if="form.period"
                    >Unlimited Period</span>
                    <span v-if="!form.period">
                     Limited Period
                    </span>
                    </v-col>
                  </v-row>
                  </v-col>
                </v-row>

              <!-- Status -->
              <v-row>
                <!-- <v-col md="3">
                    <v-text-field class="form-control" label="Status" disabled></v-text-field>
                  </v-col>-->
                <v-col md="12" class="pb-0">
                  <label v-if="enableEdit == false">{{$t('status')}}</label>
                  <label v-if="isEdit == true && enableEdit == true">
                    <b class="text--black">{{$t('status')}}</b>
                  </label>
                </v-col>
                <v-col cols="6" class="pt-0">
                  <v-select class="pt-0"  item-text="name"
                    item-value="id" v-model="form.status" :items="[{id: false, name: $t('inactive')},{id: true, name: $t('active')}]"
                    :disabled="isEdit == true && enableEdit == false"></v-select>
                  
                </v-col>
                <v-col cols="6" class="pt-0">
                  <v-card class="pa-2" style="border-radius: 4px; font-size: 12px;">
                  <span v-if="form.status">{{$t('this_will_be_show_on_mobile')}}</span>
                  <span v-if="!form.status">
                    {{$t('this_info')}}
                    <b>{{$t('not')}}</b> {{$t('show_on_mobile')}}
                  </span>
                  </v-card>
                </v-col>
              </v-row>

              <!-- End Row -->
            </v-card-text>
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-3">
          <v-row align="center" justify="center">
         <v-col cols="3">
            <v-btn @click="addEditDialog = false">{{$t('cancel')}}</v-btn>
          </v-col >
          <v-col cols="3">
            <v-btn :loading="loading" color="primary" @click="save(form)"
              :disabled="isEdit == true && enableEdit == false">{{$t('save')}}</v-btn>
          </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container>
      <h2 class="mt-5 mb-8">{{$t('news_feed')}}</h2>
      <v-card class="px-6 pb-0 mb-3 mt-3">
        <v-row>
          <v-col md="3" class="mt-2">
            <v-btn color="primary" dark class="mb-2" @click="openAddEditDialog()" block>{{$t('add')}}
              {{$t('news_feed')}}</v-btn>
          </v-col>

          <v-col md="3">
            <v-autocomplete ref="tabletop" :label="$t('status')" :items="[
                { id: '', name: `${$t('all')} ${$t('status')}` },
                { id: true, name: $t('active') },
                { id: false, name: `${$t('not')} ${$t('active')}` },
              ]" v-model="status" item-text="name" item-value="id" @change="getData()"></v-autocomplete>
          </v-col>
          <v-col>
            <v-text-field :rules="[validator.alfaNumberNotRequired]" class="form-control" :label="$t('search')"
              v-model="search" prepend-inner-icon="mdi-magnify" clearable></v-text-field>
          </v-col>
          <!-- <v-col md="3" class="pa-6">
            <v-btn block color="primary" @click="onSelectUser">
              <v-icon>mdi-magnify</v-icon>Search
            </v-btn>
          </v-col>-->
        </v-row>
      </v-card>
    </v-container>

    <v-container>
      <v-card style="position: relative" ref="tableheight">
        <v-data-table v-if="!firstLoad" :loading="loading" :headers="headers" :items="items" class="elevation-1"
          :disable-sort="disableSort" :server-items-length="totalData" :items-per-page="itemPerPage"
          :footer-props="{ 'items-per-page-options': [10, 50, 100], 'items-per-page-text': $t('rows_per_page')  }"
          :page="page" @update:page="getData($event, itemPerPage)" @update:items-per-page="getData(page, $event)"
          :no-data-text="$t('no_data')">
          <template v-slot:item.start_date="{ item }">
            {{ dateFormatted(item.start_date) }} - <span v-if="item.end_date">{{dateFormatted(item.end_date) }}</span>
            <span v-else>No End Date</span> </template>
          <template v-slot:item.groupId="{ item }">
            <span class="truncate-this" 
              style="max-width: 100px;
                      white-space: nowrap;
                      overflow: overlay;
                      overflow-x: hidden;
                      text-overflow: ellipsis;
                      display: block;">
              <span v-if="!item.groupId">
                {{$t('all')}}
              </span>
              <span v-if="item.groupId && item.groupId.length > 1" >
              <span v-for="(item, index) in item.groupId" :key="index">
                {{item.alias}},
              </span>
              </span>
            <span  v-if="item.groupId && item.groupId.length === 1">
             <span v-for="(item, index) in item.groupId" :key="index">
                {{item.alias}}
              </span>
              </span>
            </span>
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn icon @click="openAddEditDialog(true, item)" color="primary">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.isActive="{ item }">
            <span v-if="item.isActive"
              style="background: rgba(113, 203, 79, 0.1); color: #71CB4F; padding: 8px; border-radius: 12px;">{{$t('active')}}</span>
            <span v-if="!item.isActive"
              style="background: rgba(230, 74, 77, 0.1); color: #E64A4D; padding: 8px; border-radius: 12px;">{{$t('not')}}
              {{$t('active')}}</span>
          </template>
          <template v-slot:item.subject="{ item }">
            <a v-if="isUrl(item.subject)" target="_blank" :href="item.subject">
              {{ item.subject }}
            </a>
            <p v-else>{{ item.subject }}</p>
          </template>
          <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}}
            {{ items.itemsLength }} </template>
        </v-data-table>


        <div class="loader" v-if="loadingNew">
          <div class="loader-children">
          </div>
        </div>
      </v-card>
      <v-skeleton-loader class="mx-auto" type="table-tbody" v-if="firstLoad && loading"></v-skeleton-loader>

    </v-container>
  </div>
</template>
<script>
  import axios from "axios"
  import * as moment from "moment"
  import ENV from './../../store/modules/environtment'

  export default {
    name: "newsfeeed",
    data() {
      return {
        loadingImg: false,
        loadingNew: false,
        form: {
          id: null,
          start_date: null,
          end_date: null,
          groupId: [],
          avatar: 'img/add-image.png',
          image: {
            one: {
              data: null,
              url: 'img/add-image.png',
              path: null
            },
            two: {
              data: null,
              url: 'img/add-image.png',
              path: null
            },
            three: {
              data: null,
              url: 'img/add-image.png',
              path: null
            },
          },
        },
        isEdit: false,
        enableEdit: false,
        addEditDialog: false,
        groupList: [],
        firstLoad: true,
        disableSort: true,
        totalData: 0,
        page: 1,
        itemPerPage: 10,
        headers: [{
            text: "Period Date",
            value: "start_date",
            width: '30%',
            align: "left"
          },
          {
            text: this.$i18n.t('group'),
            value: "groupId",
            width: '10%',
            align: "left"
          },
          {
            text: this.$i18n.t('title'),
            value: "subject",
            width: '10%',
            align: "left"
          },
          {
            text: this.$i18n.t('description'),
            value: "description",
            width: '40%',
            align: "left"
          },
          {
            text: this.$i18n.t('status'),
            value: "isActive",
            width: '20%',
            align: "left"
          },
          {
            text: this.$i18n.t('action'),
            value: "action",
            width: '10%',
            align: "left"
          },
        ],
        validator: this.$store.state.validator,
        baseUrl: this.$store.state.baseUrl,
        rules2: [(v) => v.length > 0 || this.$i18n.t('required')],
        status: '',
        loading: true,
        editedIndex: -1,
        search: "",
        userList: [],
        items: [],
        menu_start: false,
        menu_end: false,
         menu_start2: false,
        menu_end2: false,
        start_date: "",
        end_date: "",
        addItem: {
          categoryCode: "",
          categoryName: "",
          groupAccess: [],
        },
        editItem: {
          categoryCode: "",
          categoryName: "",
          groups: [],
        },
      };
    },
    computed: {
      addAllGroup() {
        return this.addItem.groupAccess.length === this.groupList.length;
      },
      addAll() {
        return this.addItem.groupAccess.length > 0 && !this.addAllGroup;
      },
      editAllGroup() {
        return this.editItem.groups.length === this.groupList.length;
      },
      editAll() {
        return this.editItem.groups.length > 0 && !this.editAllGroup;
      },
      icon() {
        if (this.addAllGroup) return "mdi-close-box";
        if (this.addAll) return "mdi-minus-box";
        return "mdi-checkbox-blank-outline";
      },
      iconEdit() {
        if (this.editAllGroup) return "mdi-close-box";
        if (this.editAll) return "mdi-minus-box";
        return "mdi-checkbox-blank-outline";
      },
    },
    methods: {
      chooseFiles1: function () {
        document.getElementById("image1").click()
      },
       chooseFiles2: function () {
        document.getElementById("image2").click()
      },
       chooseFiles3: function () {
        document.getElementById("image3").click()
      },
      changePeriod(period){
        if(period){
        this.form.end_date = null
        }else{
        this.form.end_date = this.form.start_date
        }
      },
      async fetchGroupDetails() {
        this.groupList = await this.$store.dispatch('getTaskAssignmentByRole', {
          userId: this.user_id
        })
      },
      toggle() {
        this.$nextTick(() => {
          if (this.addAllGroup) {
            this.addItem.groupAccess = [];
          } else {
            this.groupList.map((group) => {
              this.addItem.groupAccess.push(group.id)
            })
            // this.addItem.groupAccess = this.groupList.slice();
          }
        });
      },
      toggleEdit() {
        this.$nextTick(() => {
          if (this.editAllGroup) {
            this.editItem.groups = [];
          } else {
            this.groupList.map((group) => {
              this.editItem.groups.push(group.id)
            })
            // this.editItem.groups = this.groupList.slice();
          }
        });
      },
      limitChar(str, limit, type) {
        if (str.length > limit) {
          this.showMessage('warning', this.$i18n.t('reach_max_limit_char'))
          this.form[type] = str.substr(0, limit)
        }
      },
      isUrl(s) {
        // eslint-disable-next-line no-useless-escape
        const regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
        return regexp.test(s);
      },
      setAltImage(event) {
        event.target.src = 'img/add-image.png'
      },
      showMessage(type, msg) {
        this.$store.dispatch('nShowMessage', {
          type,
          msg
        })
      },
      setEnableEdit() {
        this.enableEdit = true
      },
      async firstData(page = 1, itemPerPage = 10) {
        this.loading = true
        this.page = page
        this.itemPerPage = itemPerPage
        const totalPageSend = itemPerPage < 1 ? this.totalData : itemPerPage;
        const start = this.page - 1;
        const dateStart = moment(this.start_date).format('DD-MM-YYYY')
        const dateEnd = moment(this.end_date).format('DD-MM-YYYY')
        const params = {
          page: start,
          pageSize: totalPageSend,
          isMobile: false,
          startDate: dateStart,
          endDate: dateEnd,
          isActive: this.status
        }
        const result = await this.$store.dispatch('getNewsFeedData', params)
        this.loading = false
        this.items = result.rows
        this.totalData = result.count

        this.$refs.tabletop.$el.scrollIntoView({
          behavior: 'smooth'
        })
        this.loadingNew = false
        this.firstLoad = false
      },

      async getData(page = 1, itemPerPage = 10) {
        this.loading = true
        this.loadingNew = true
        this.page = page
        this.itemPerPage = itemPerPage
        const totalPageSend = itemPerPage < 1 ? this.totalData : itemPerPage;
        const start = this.page - 1;
        const dateStart = moment(this.start_date).format('DD-MM-YYYY')
        const dateEnd = moment(this.end_date).format('DD-MM-YYYY')
        const params = {
          page: start,
          pageSize: totalPageSend,
          isMobile: false,
          startDate: dateStart,
          endDate: dateEnd,
          isActive: this.status,
        }
        const result = await this.$store.dispatch('getNewsFeedData', params)
        this.items = result.rows
        this.totalData = result.count

        this.$refs.tabletop.$el.scrollIntoView({
          behavior: 'smooth'
        })
        this.loading = false
        this.loadingNew = false
        this.firstLoad = false
      },
      async save(form) {
        const prefix = ENV.firebase.prefixNewsFeed
        const companyId = this.$store.state.company
        const userId = this.$store.state.user.id

         if(this.isEdit){
          form.groupId = this.editItem.groups
          }else{
          form.groupId = this.addItem.groupAccess
          }
        const attachmentPrefix = `${prefix}${companyId}/${userId}/news_feed`
        const body = {
          id: form.id,
          subject: form.subject,
          description: form.description,
          attachmentPrefix,
          start_date: form.start_date,
          end_date: form.end_date ? form.end_date : null,
          attachments: [{
              attachment: form.image.one.path,
              isCover: true
            },
            {
              attachment: form.image.two.path,
              isCover: false
            },
            {
              attachment: form.image.three.path,
              isCover: false
            },
          ],
          isActive: form.status,
          groupId: form.groupId
         
        }
        if (body.subject.length > 100) {
          this.showMessage('warning', `${this.$i18n.t('subject')} ${this.$i18n.t('reach_max_limit_char')}`)
          return null
        }
        if (body.description.length > 2000) {
          this.showMessage('warning', `${this.$i18n.t('description')} ${this.$i18n.t('reach_max_limit_char')}`)
          return null
        }

        let result
        this.loading = true
        if (this.isEdit) {
          result = await this.$store.dispatch('editNewsFeed', body)
        } else {
          result = await this.$store.dispatch('saveNewsFeed', body)
        }
        this.loading = false
        if (result) {
          this.showMessage('success',
            `${this.isEdit ? this.$i18n.t('edit') : this.$i18n.t('alert_save')} ${this.$i18n.t('success')}`)
          this.addEditDialog = false
          this.getData(this.page, this.itemPerPage)
        }


      },

      async previewImage(num) {
        switch (num) {
          case 1:
            if (this.form.image.one.data) {
              this.loadingImg = true
              const data = await this.uploadImage(this.form.image.one.data)
              this.loadingImg = false
              this.form.image.one.url = URL.createObjectURL(this.form.image.one.data)
              this.form.image.one.path = data.fileName
            } else {
              this.form.image.one.url = 'img/add-image.png'
            }
            break
          case 2:
            if (this.form.image.two.data) {
              this.loadingImg = true
              const data = await this.uploadImage(this.form.image.two.data)
              this.loadingImg = false
              this.form.image.two.url = URL.createObjectURL(this.form.image.two.data)
              this.form.image.two.path = data.fileName
            } else {
              this.form.image.two.url = 'img/add-image.png'
            }
            break
          case 3:
            if (this.form.image.three.data) {
              this.loadingImg = true
              const data = await this.uploadImage(this.form.image.three.data)
              this.loadingImg = false
              this.form.image.three.url = URL.createObjectURL(this.form.image.three.data)
              this.form.image.three.path = data.fileName
            } else {
              this.form.image.three.url = 'img/add-image.png'
            }
            break
        }
      },
      openAddEditDialog(isEdit = false, item = null) {
        this.isEdit = isEdit
        this.enableEdit = false
        this.addEditDialog = true
        if (isEdit) {
          const tmp = [];
           if(item.groupId){
          item.groupId.map((edit) => {
            tmp.push(edit.id);
              });
          }
          this.editItem.groups = tmp;
          this.addItem.groupAccess = tmp;
          this.form.id = item.id
          this.form.subject = item.subject
          this.form.start_date = item.start_date
          this.form.end_date = item.end_date
          this.form.description = item.description
          this.form.image.one.url = item.attachments[0] ? item.attachments[0].attachment : 'img/add-image.png'
          this.form.image.two.url = item.attachments[1] ? item.attachments[1].attachment : 'img/add-image.png'
          this.form.image.three.url = item.attachments[2] ? item.attachments[2].attachment : 'img/add-image.png'
          this.form.status = item.isActive
          this.setEnableEdit()
        }
      },
      dateFormatted(date) {
        return moment(date).locale(this.$i18n.t('lang')).format("DD MMMM YYYY");
      },
      dateFormattedHour(date) {
        return moment(date).format("HH:mm:ss");
      },
      queryDate(date) {
        return moment(date).format("MM-DD-YYYY");
      },
      queryDatePlus(date, day) {
        return moment(date)
          .add(day, "days")
          .format("MM-DD-YYYY");
      },
      onSelectUser() {
        // setTimeout(() => {
        //   this.id = "";
        // }, 3000);
      },
      onStartDateChange() {
        const diff = moment(this.end_date).diff(this.start_date, 'days')
        if (diff < 0) this.end_date = this.start_date
        this.menu_start = false;
        this.getData()
      },
      onEndDateChange() {
        this.menu_end = false;
        this.getData()
      },
        onStartDateChange2() {
        const diff = moment(this.form.end_date).diff(this.form.start_date, 'days')
        if (diff < 0) this.form.end_date = this.form.start_date
        this.menu_start2 = false;
      },
      onEndDateChange2() {
        this.menu_end2 = false;
      },

      async getUserList() {
        let company_id = this.$store.state.company;
        const result = await this.$store.dispatch('getEmployeeListNoPagination', {
          companyId: company_id
        })
        this.userList = result.rows;
      },

      async uploadImage(image) {
        const prefix = ENV.firebase.prefixNewsFeed
        const companyId = this.$store.state.company
        const url = `${this.baseUrl}/download/fileupload`
        const headers = {
          headers: {
            'Content-Type': 'multipart/form-data',
            action: 'File Upload',
            actionId: 1
          }
        }
        try {
          const formData = new FormData();
          formData.append('file', image)
          formData.append('path', `${prefix}${companyId}`)

          const result = await axios.post(url, formData, headers)
          if (result) {
            if (result.data.code == 200) return result.data.data
          }
          return {
            url: 'img/add-image.png'
          }
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e.message)
          return {
            url: 'img/add-image.png'
          }
        }
      },
    },
    watch: {
      addEditDialog(show) {
        if (show && !this.isEdit) {
          this.form = {
            avatar: 'img/add-image.png',
            image: {
              one: {
                data: null,
                url: 'img/add-image.png',
                path: null
              },
              two: {
                data: null,
                url: 'img/add-image.png',
                path: null
              },
              three: {
                data: null,
                url: 'img/add-image.png',
                path: null
              },
            },
          }
        } else {
          if (this.$refs.watchForm) {
            // this.$refs.watchForm.reset()
          }
        }
      },
    },
    created() {
      this.fetchGroupDetails();
      this.start_date = moment('2019', 'YYYY')
        .startOf("month")
        .format("YYYY-MM-DD");
      this.form.end_date = moment().format("YYYY-MM-DD");
      this.form.start_date = moment().format("YYYY-MM-DD");
      this.end_date = moment().format("YYYY-MM-DD");
      this.firstData()
    }
  };
</script>

<style scoped>
  .cont_period::before{
    content: 'Continuous Period';
    font-size: 12px;
    position: absolute;
    bottom: 75px;
    left: 10px;
    height: 10px;
    width: 200px;
  }

  .loader {
    background: white;
    height: 100%;
    width: 100%;
    opacity: .55;
    position: absolute;
    top: 50%;
    left: 50%;
    border-radius: 4px;
    transform: translate(-50%, -50%);
  }


  .dot-falling {
    position: relative;
    left: -9999px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #2d9ada;
    color: #2d9ada;
    box-shadow: 9999px 0 0 0 #2d9ada;
    animation: dotFalling 1s infinite linear;
    animation-delay: .1s;
  }

  .dot-falling::before,
  .dot-falling::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
  }

  .dot-falling::before {
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #2d9ada;
    color: #2d9ada;
    animation: dotFallingBefore 1s infinite linear;
    animation-delay: 0s;
  }

  .dot-falling::after {
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #2d9ada;
    color: #2d9ada;
    animation: dotFallingAfter 1s infinite linear;
    animation-delay: .2s;
  }

  @keyframes dotFalling {
    0% {
      box-shadow: 9999px -15px 0 0 rgba(152, 128, 255, 0);
    }

    25%,
    50%,
    75% {
      box-shadow: 9999px 0 0 0 #2d9ada;
    }

    100% {
      box-shadow: 9999px 15px 0 0 rgba(152, 128, 255, 0);
    }
  }

  @keyframes dotFallingBefore {
    0% {
      box-shadow: 9984px -15px 0 0 rgba(152, 128, 255, 0);
    }

    25%,
    50%,
    75% {
      box-shadow: 9984px 0 0 0 #2d9ada;
    }

    100% {
      box-shadow: 9984px 15px 0 0 rgba(152, 128, 255, 0);
    }
  }

  @keyframes dotFallingAfter {
    0% {
      box-shadow: 10014px -15px 0 0 rgba(152, 128, 255, 0);
    }

    25%,
    50%,
    75% {
      box-shadow: 10014px 0 0 0 #2d9ada;
    }

    100% {
      box-shadow: 10014px 15px 0 0 rgba(152, 128, 255, 0);
    }
  }

  .loading-dots {
    position: fixed;
    top: 50%;
    left: 55%;
    transform: translate(-50%, -55%);
    transform: -webkit-translate(-50%, -55%);
    transform: -moz-translate(-50%, -55%);
    transform: -ms-translate(-50%, -55%);
    z-index: 99;
  }

  .truncate-table {
    max-width: 1px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .allow-hover:hover {
    cursor: pointer;
  }

</style>